import i18n from './i18n';
const { lang, currency } = i18n;
export const formatPrice = (price) => {
    if (!price || price < 0)
        return 'R$ 0,00';
    const formattedPrice = price.toLocaleString(lang, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
    });
    return formattedPrice;
};
